import { Component, EventEmitter, ViewChild, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { HttpService } from 'src/app/services/http.service';
import { Projet } from '../../bo/projet';
import { ProprieteAffichee } from '../../bo/proprieteAffichee';
import { WorkflowModele } from '../../bo/workflowModele';
import { LocalizedDatePipe } from '../../pipes/localized-date.pipe';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { UtilisateurService } from '../../services/utilisateur.service';
import { ProjetModaleComponent } from '../projet-modale/projet-modale.component';
import { SiteReportsModaleComponent } from '../site-reports-modale/site-reports-modale.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-mes-projets',
  templateUrl: './mes-projets.component.html',
  styleUrls: ['./mes-projets.component.scss'],
  standalone: false
})

export class MesProjetsComponent {
  @ViewChild('modalNoWorkflow') modalNoWorkflow: ModalDirective;
  @ViewChild('modalExport') modalExport: ModalDirective;
  proprietesAfficheesProjets = signal<ProprieteAffichee[]>([]);
  modaleAjout = signal<BsModalRef>(null);
  tabProjets = signal<Projet[]>([]);
  siteId = signal<number>(0);
  erreurRecuperation = signal<boolean>(false);
  listeModifiee = new EventEmitter<any>();
  aucuneDonnee = signal<boolean>(false);

  constructor(private readonly utilisateurService: UtilisateurService, private readonly modalService: BsModalService, private readonly http: HttpService, private readonly route: ActivatedRoute, private readonly router: Router,
    private readonly localizedDatePipe: LocalizedDatePipe, private readonly fonctionsService: FonctionsService, private readonly translate: TranslateService) {

    modalService.onHide.observers = [];
    modalService.onHide.subscribe((raison: string) => {
      if (this.modaleAjout() && this.modaleAjout().content && !this.modaleAjout().content.annul) {
        var projetId = this.tabProjets().findIndex(p => p.projetId == this.modaleAjout().content.projet.projetId);
        // Modif
        if (projetId != -1) {
          const projets = [...this.tabProjets()];
          Object.assign(projets[projetId], this.modaleAjout().content.projet);
          this.tabProjets.set(projets);
        } else {
          this.tabProjets.set([...this.tabProjets(), this.modaleAjout().content.projet]);
        }
        this.listeModifiee.emit(true);
        this.modaleAjout.set(null);
      }
    });
  }

  ngOnInit() {
    this.utilisateurService.currentProjet = null;
    this.utilisateurService.currentTir = null;
    this.utilisateurService.currentEtape = null;
    this.route.params.subscribe(params => {
      var startLoader = setTimeout(() => {
        this.fonctionsService.loading_screen(true);
      }, 300);

      this.siteId.set(params.id);
      this.proprietesAfficheesProjets.set(new Projet().getProprietesAffichees());
      this.http.get<Projet[]>('Sites/' + this.siteId() + '/Projects').subscribe(resultat => {
        this.tabProjets.set(resultat);
        this.fonctionsService.loading_screen(false);
        clearTimeout(startLoader);
      }, (error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          console.log(error.error);
        }
        this.erreurRecuperation.set(true);
        this.fonctionsService.loading_screen(false);
        clearTimeout(startLoader);
      });
    });
  }

  ouvrirProjet(_projet: Projet) {
    this.router.navigate(['mysite', this.siteId(), 'myprojects', _projet.projetId], { replaceUrl: true });
  }

  ouvrirModaleAjout() {
    this.fonctionsService.loading_screen(true);
    this.http.get<WorkflowModele[]>('Sites/' + this.siteId() + '/WorkflowModeles').subscribe(resultat => {
      resultat.forEach(wkfw => wkfw.nomDate = wkfw.nom + ' (' + this.localizedDatePipe.transform(wkfw.dateDerniereModification) + ')');
      this.fonctionsService.loading_screen(false);
      if (resultat.length > 0) {
        var initialState = {
          workflows: resultat,
          estModif: false,
          siteId: this.siteId()
        };
        this.modaleAjout.set(this.modalService.show(ProjetModaleComponent, { backdrop: true, ignoreBackdropClick: true, keyboard: false, initialState }));
      } else {
        this.modalNoWorkflow.show();
      }
    }, () => {
      this.fonctionsService.loading_screen(false);
      this.translate.get('GLOBAL.ERREUR_RECUP_DONNEES').subscribe(trad => {
        this.fonctionsService.launch_toast(false, false, trad)
      });
    });
  }

  lancerExport() {
    this.fonctionsService.loading_screen(true);
    this.aucuneDonnee.set(false);
    this.http.get<boolean>('Sites/' + this.siteId() + '/GotAnalysisData').subscribe(resultat => {
      this.fonctionsService.loading_screen(false);
      if (resultat)
        this.exportDonneeAnalyse();
      else {
        this.aucuneDonnee.set(true);
        this.modalExport.show();
      }
    }, () => {
      this.fonctionsService.loading_screen(false);
    });
  }

  exportDonneeAnalyse() {
    this.modalExport.show();
    this.http.downloadFile('Sites/' + this.siteId() + '/ExportAnalysisData').subscribe((resultat: any) => {
      if (resultat) {
        const blob = new Blob([resultat.body], { type: 'base64' });
        const url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = this.utilisateurService.currentSite()?.nom + ".csv";
        document.body.appendChild(a);
        a.click();
        this.modalExport.hide();
        setTimeout(() => {
          a.remove();
        }, 100);
      } else {
        this.fonctionsService.launch_toast(false);
      }
    }, () => {
      this.translate.get('GLOBAL.ERREUR_RECUP_DONNEES').subscribe(trad => {
        this.fonctionsService.launch_toast(false, false, trad)
      });
      this.modalExport.hide();
    });
  }

  openModalReports() {
    this.modalService.show(SiteReportsModaleComponent, {
      initialState: { siteId: this.siteId(), tabProjets: this.tabProjets() } as Partial<SiteReportsModaleComponent>,
    });
  }
}
